/**
 * Renders a checkbox component
 *
 * @property {string} [className]
 * @property {boolean} [defaultChecked]
 * @property {boolean} [disabled]
 * @property {string} id
 * @property {string} label
 * @property {string} name
 * @property {function} onChange
 * @property {string} value
 */

import React from 'react';

const Checkbox = class Checkbox extends React.Component {
    render() {
        const {
            className,
            defaultChecked,
            disabled,
            id,
            label,
            name,
            onChange,
            required,
            value
        } = this.props;

        return (
            <div className={`cbox${className ? ` ${className}` : ''}`}>
                <input
                    aria-required={required}
                    className="cbox__input"
                    checked={defaultChecked}
                    disabled={disabled}
                    id={id}
                    onChange={e => onChange(e)}
                    name={name}
                    required={required}
                    type="checkbox"
                    value={value || true}
                />

                <label
                    className="cbox__lbl"
                    htmlFor={id}
                >
                    {label}
                </label>
            </div>
        )
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/app/components/Common/Checkbox.js